import { createContext } from "react";

const DarkContext = createContext();

export default DarkContext;